import { Alert, Empty, Skeleton } from 'antd'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchPublicCategories, fetchPublicTopics, type PublicApiError, type PublicTermSummary } from './publicApi'

export default function PublicTermListPage({
  workspaceSlug,
  siteSlug,
  kind,
  title,
}: {
  workspaceSlug: string
  siteSlug: string
  kind: 'category' | 'topic'
  title: string
}) {
  const [terms, setTerms] = useState<PublicTermSummary[] | null>(null)
  const [error, setError] = useState<string | null>(null)
  const base = `/site/${workspaceSlug}/${siteSlug}`
  const listPath = kind === 'category' ? 'categories' : 'topics'

  useEffect(() => {
    setTerms(null)
    setError(null)
    const fetcher = kind === 'category' ? fetchPublicCategories : fetchPublicTopics
    fetcher(workspaceSlug, siteSlug)
      .then((r) => setTerms(r.data.items))
      .catch((err) => setError((err as PublicApiError).message))
  }, [workspaceSlug, siteSlug, kind])

  if (error) return <div className="pub-page"><Alert type="error" message={error} showIcon /></div>

  return (
    <div className="pub-page">
      <h1>{title}</h1>
      {terms === null ? (
        <Skeleton active paragraph={{ rows: 4 }} />
      ) : terms.length === 0 ? (
        <Empty className="pub-empty" description={`暂无${title}`} />
      ) : (
        <div className="pub-category-grid" style={{ marginTop: 24 }}>
          {terms.map((t) => (
            <Link key={t.slug} to={`${base}/${listPath}/${t.slug}`} className="pub-category-card">
              <h3>{t.name}</h3>
              <span>{t.item_count} 条目</span>
              {t.description && <p style={{ margin: '0.5rem 0 0', color: '#666', fontSize: '0.85rem' }}>{t.description}</p>}
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
